import { VisualQC } from '../../../modules/Common/VisualQCStatus';

import { FSNModel } from '../../../types/common';
import { colors } from '../../../utils/constants/colors';
import { VisualQCStatus } from '../../../utils/enums';
import Warn from '../../../icons/warn.svg';

interface ClickableStatusButtonProps {
    fsn: FSNModel;
    fullWidth?: boolean;
    showVisualQC?: boolean;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const ClickableStatusButton = ({ fullWidth, onClick, fsn, showVisualQC = false }: ClickableStatusButtonProps) => {
    const { fsn: label, status, error } = fsn;

    // const type = fsn.visualQCStatus === VisualQCStatus.PENDING ? 'none' : fsn.visualQCStatus === VisualQCStatus.PASSED ? 'success' : 'error';
    const type = fsn.status ? (fsn.visualQCStatus === VisualQCStatus.PENDING ? 'none' : fsn.visualQCStatus === VisualQCStatus.PASSED ? 'success' : 'error') : 'info';
    const errorTitle = error?.message ? `MESSAGE : ${error.message}, STAGE: ${error.stage}` : '';

    const showError = !fsn.status;

    if (!label) return null;

    console.log('type', type);

    const buttonStyle = {
        backgroundColor: colors[type] || '#FFFFFF',
        cursor: fsn.status ? 'pointer' : 'default',
        color: !fsn.status ? '#9A9A9A' : '#101828',
        fontWeight: 500,
        fontSize: 14,
        height: 72,
        border: '1px solid #E7F8EC'
    };

    return (
        <button onClick={onClick} type="button" className={`flex flex-col justify-center gap-1  px-4 mt-1 text-center text-sm  ${fullWidth ? 'w-full' : 'w-auto'}`} style={buttonStyle} title={errorTitle}>
            {label}

            <div className={'flex flex-row gap-1'}>
                {showVisualQC && [VisualQCStatus.PASSED, VisualQCStatus.FAILED].includes(fsn.visualQCStatus) && <VisualQC status={fsn.visualQCStatus} />}
                {showError && (
                    <div className={`flex text-white py-1 px-1 inline-flex rounded-full`} style={{ border: '1px solid rgba(0, 0, 0, 0.15)' }}>
                        <img src={Warn} alt="" className="mr-1" />
                        <span style={{ fontSize: 12, fontWeight: 400, marginRight: 8, color: '#FF4D4D' }}>Pipeline Failed</span>
                    </div>
                )}
                {/* {showVisualQC && [VisualQCStatus.PASSED, VisualQCStatus.FAILED].includes(fsn.visualQCStatus) && <VisualQC status={fsn.visualQCStatus} />} */}
            </div>
        </button>
    );
};

export default ClickableStatusButton;
